import React from 'react';
import { styles } from './InstallAccessorySection.css';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

type InstallAccessorySectionProps = {
  heading?: string;
  subheading?: string;
  children: React.ReactNode;
  isNarrowLayout?: boolean;
};

export const InstallAccessorySection = ({
  heading,
  subheading,
  children,
  isNarrowLayout = false,
}: InstallAccessorySectionProps) => {
  return (
    <section className={styles.section}>
      {heading || subheading ? (
        <div className={styles.header}>
          {heading ? (
            <CalloutFont as="h4" className={styles.heading}>
              {heading}
            </CalloutFont>
          ) : null}
          {subheading ? <p className={styles.subheading({ isNarrow: isNarrowLayout })}>{subheading}</p> : null}
        </div>
      ) : null}

      {children}
    </section>
  );
};
